import React from "react";
import { FiMapPin, FiPhone, FiMail, FiClock } from "react-icons/fi";

const Contact = () => {
  const contact = {
    address: "Avenue Beethoven, Résidence Oumnia 1, Bureau 83, Tanger – Maroc",
    phone1: "0539 34 24 94",
    phone2: "0606 06 61 62",
    email: "contact@maxula.ma",
    hours: "Lun–Sam • 10:00 – 19:00"
  };

  return (
    <div className="bg-white">
      {/* HERO */}
      <section className="relative w-full overflow-hidden">
        <div className="relative w-full h-[320px] md:h-[380px] flex">
          <div
            className="relative z-10 flex items-center text-white"
            style={{
              width: "55%",
              backgroundColor: "#e11d7b",
              clipPath: "polygon(0 0, 100% 0, 92% 35%, 78% 100%, 0 100%)"
            }}
          >
            <div className="max-w-xl pl-8 md:pl-16 pr-10">
              <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
                Contact
              </h1>
              <p className="mt-4 text-base md:text-lg text-white/90">
                Nous répondons rapidement — clients, partenaires, demandes VIP.
              </p>
            </div>
          </div>

          <div
            className="absolute right-0 top-0 h-full w-full"
            style={{
              background:
                "linear-gradient(to right, #e11d7b 0%, rgba(225,29,123,0.55) 45%, rgba(225,29,123,0.15) 70%, transparent 100%)"
            }}
          />
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-6">
          <div className="bg-white border rounded-2xl p-6">
            <h2 className="text-xl font-bold text-gray-900 mb-4">
              Coordonnées
            </h2>

            <div className="space-y-4 text-gray-700">
              <div className="flex gap-3">
                <FiMapPin className="text-[#e11d7b] mt-0.5" />
                <div>{contact.address}</div>
              </div>

              <div className="flex gap-3 items-start">
                <FiPhone className="text-[#e11d7b] mt-0.5" />
                <div>
                  <a className="hover:underline" href={`tel:${contact.phone1}`}>
                    {contact.phone1}
                  </a>
                  <span className="mx-2 text-gray-300">•</span>
                  <a className="hover:underline" href={`tel:${contact.phone2}`}>
                    {contact.phone2}
                  </a>
                </div>
              </div>

              <div className="flex gap-3">
                <FiMail className="text-[#e11d7b] mt-0.5" />
                <div>
                  <a className="hover:underline" href={`mailto:${contact.email}`}>
                    {contact.email}
                  </a>
                </div>
              </div>

              <div className="flex gap-3">
                <FiClock className="text-[#e11d7b] mt-0.5" />
                <div>{contact.hours}</div>
              </div>
            </div>
          </div>

          <div className="bg-pink-50 border border-pink-100 rounded-2xl p-6">
            <h2 className="text-xl font-bold text-[#7a1147] mb-4">
              Emails par pôle
            </h2>

            <div className="space-y-3 text-gray-700">
              <div className="bg-white rounded-xl border p-4">
                <div className="font-semibold text-gray-900">Maxula.ma</div>
                <div className="text-sm text-gray-600">Demandes générales</div>
                <a className="text-[#e11d7b] font-semibold hover:underline" href="mailto:contact@maxula.ma">
                  contact@maxula.ma
                </a>
              </div>

              <div className="bg-white rounded-xl border p-4">
                <div className="font-semibold text-gray-900">Maxula Laser Clinic</div>
                <div className="text-sm text-gray-600">Laser / esthétique</div>
                <a className="text-[#e11d7b] font-semibold hover:underline" href="mailto:laser@maxula.ma">
                  laser@maxula.ma
                </a>
              </div>

              <div className="bg-white rounded-xl border p-4">
                <div className="font-semibold text-gray-900">Maxula House</div>
                <div className="text-sm text-gray-600">Immobilier / expatriés</div>
                <a className="text-[#e11d7b] font-semibold hover:underline" href="mailto:house@maxula.ma">
                  house@maxula.ma
                </a>
              </div>
            </div>

            <div className="mt-5 text-sm text-gray-600">
              Adresse bureau : <b>{contact.address}</b>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
